import Icon from '../components/Icon.vue'

Icon.register({
  'file-archive': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7zM128.4 336c17.9 0 32.5 12.1 32.5 27s-14.5 27-32.4 27-32.5-12-32.5-27c0-14.9 14.5-27 32.4-27zM224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h104.4v32h32v-32h63.6v136zM95.9 32v32h32v-32h-32zM128.2 416c33 0 57.8-30.2 51.4-62.6l-17.3-87.7c-1.1-5.6-6.1-9.7-11.8-9.7h-22.1v-32h32v-32h-32v-32h32v-32h-32v-32h32v-32h-32v32h-32v32h32v32h-32v32h32v32h-32v32l-19.6 97.1c-6.6 32.5 18.2 62.9 51.4 62.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-archive.js
// module id = 1325
// module chunks = 0